import { LottieImage } from '../models/abre-cuentas.model';

/**
 * Inicializaión de la clase ErrorModel, modelo de los errores para la aplicación
 *
 * *Set ErrorModel class, application error model*
 *
 * @access public
 * @type {class}
 */

export class ErrorModel {

  /**
   * Codigo de error
   *
   * *Error code*
   *
   * @type {string} type
   */
  CODE?: string;

  /**
   * Tipo de error
   *
   * *Error type*
   *
   * @type {string} type
   */
  type: string;

  /**
   * Error image
   *
   * *Imagen del error*
   *
   * @type {LottieImage | string} image
   */
  image?: LottieImage | string;

  /**
   * Título del error
   *
   * *Error title*
   *
   * @type {string} title
   */
  title?: string;

  /**
   * Descripción del error
   *
   * *Description error*
   *
   * @type {string | string[]} description
   */
  description?: string | string[];

  /**
   * Mostrar link de las oficinas
   *
   * *Show link offices*
   *
   * @type {boolean} showLinkOffices
   */
  showLinkOffices?: boolean;

  /**
   * Mostrar link de las configuraciones del teléfono
   *
   * *Show link settings*
   *
   * @type {boolean} showLinkSettings
   */
  showLinkSettings?: boolean;

  /**
   * Texto del botón de error
   *
   * *Button label error*
   *
   * @type {string} buttonLabel
   */
  buttonLabel: string;

  /**
   * Acción del botón de error
   *
   * *Button action error*
   *
   * @type {string} buttonAction
   */
  buttonAction: string;

  /**
   * Informacion adicional
   *
   * *textos informacion adicional*
   *
   * @type {ISpecificInfoModel} specificInfo
   */
  specificInfo?: ISpecificInfoModel;
}

export interface ISpecificInfoModel {
  title: string;
  value: string;
}
